import { FileSpreadsheet } from 'lucide-react';

export function TaxSchedulePage() {
  return (
    <div className="space-y-6 animate-fadeIn">
      <h1 className="text-2xl font-bold" style={{ color: 'var(--text-primary)' }}>別表入力・確認</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {['別表一（一）', '別表四', '別表五（一）', '別表五（二）', '別表十六（一）', '別表十六（二）'].map(name => (
          <div key={name} className="card p-6 hover:shadow-md transition-shadow cursor-pointer">
            <FileSpreadsheet size={32} className="mb-4" style={{ color: 'var(--accent-color)' }} />
            <h3 className="font-semibold" style={{ color: 'var(--text-primary)' }}>{name}</h3>
            <p className="text-sm mt-1" style={{ color: 'var(--text-secondary)' }}>クリックして編集</p>
          </div>
        ))}
      </div>
    </div>
  );
}

